<template>
  <div class="image-container">
    <div class="image-container-header">
      <p class="ml-2 mt-1">{{ file.fileName }}</p>
      <v-btn text color="white" @click="viewFullSreen" :icon="isMobile">
        <template v-if="!isMobile">
          Full-Screen
        </template>
        <v-icon :class="{ 'ml-3': !isMobile }">mdi-fullscreen</v-icon>
      </v-btn>
    </div>
    <v-img :src="file.src" class="mt-2" aspect-ratio="1" contain />
    <PDFViewFull :data="documentDialog" />
  </div>
</template>

<script>
import PDFViewFull from "@/components/common/PDFViewFull";

export default {
  props: {
    file: {
      type: Object,
      required: true
    }
  },
  components: { PDFViewFull },
  data() {
    return {
      documentDialog: { dialog: false }
    };
  },
  methods: {
    viewFullSreen() {
      this.documentDialog.src = this.file.src;
      this.documentDialog.title = this.file.fileName;
      this.documentDialog.dialog = true;
    }
  }
};
</script>

<style lang="scss">
.image-container {
  background: $background-selected;
  margin-bottom: 50px;
  &-header {
    background: $dark-background;
    color: white;
    display: flex;
    justify-content: space-between;
    padding: 5px;

    p {
      margin-bottom: 0 !important;
    }
  }
}
</style>
